import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(activity)/diva-eyeglasses/components/DivaEyeglassesContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
